import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer/user-log'
// Modules
import userLog from './user-log'

const initialState = () => ({
    userLogs: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        userLogs: state => state.userLogs.data,
        pagination: state => state.userLogs.pagination
    },
    actions: {
        /**
         * @param {{customerId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listUserLogs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listUserLogs(data)
                const userLogs = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_USER_LOGS, userLogs)
                return userLogs
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetUserLogs: ({commit}) => commit(mutationTypes.RESET_USER_LOGS)
    },
    modules: {
        userLog
    },
    mutations: {
        [mutationTypes.RESET_USER_LOGS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_USER_LOGS]: (state, data) => state.userLogs = data
    }
}
